var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 21.25H12C12.41 21.25 12.75 20.91 12.75 20.5C12.75 20.09 12.41 19.75 12 19.75H7C4.14 19.75 2.75 18.36 2.75 15.5V8.5C2.75 5.64 4.14 4.25 7 4.25H17C19.86 4.25 21.25 5.64 21.25 8.5V11.5C21.25 11.91 21.59 12.25 22 12.25C22.41 12.25 22.75 11.91 22.75 11.5V8.5C22.75 4.85 20.65 2.75 17 2.75H7C3.35 2.75 1.25 4.85 1.25 8.5V15.5C1.25 19.15 3.35 21.25 7 21.25Z",
    fill: "#5D9FE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65978 12.08C10.3098 12.61 11.1598 12.87 11.9998 12.87C12.8398 12.87 13.6898 12.61 14.3298 12.08L17.4598 9.57996C17.7898 9.32996 17.8398 8.84997 17.5798 8.52997C17.3198 8.19997 16.8498 8.14997 16.5298 8.40997L13.3998 10.91C12.6398 11.52 11.3498 11.52 10.5898 10.91L7.45977 8.40997C7.13977 8.15997 6.66978 8.20997 6.40978 8.52997C6.14978 8.84997 6.20978 9.31996 6.52978 9.57996L9.65978 12.08Z",
    fill: "#5D9FE1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2 22.15C16.02 22.15 14.25 20.38 14.25 18.2C14.25 16.02 16.02 14.25 18.2 14.25C20.38 14.25 22.15 16.02 22.15 18.2C22.15 19.021 21.899 19.7838 21.4696 20.4158C21.4905 20.4326 21.5106 20.4506 21.5299 20.4699L22.5299 21.4699C22.8199 21.7599 22.8199 22.2399 22.5299 22.5299C22.3799 22.6799 22.1899 22.7499 21.9999 22.7499C21.8099 22.7499 21.6199 22.6799 21.4699 22.5299L20.4699 21.5299C20.4506 21.5106 20.4326 21.4905 20.4158 21.4696C19.7838 21.899 19.021 22.15 18.2 22.15ZM18.2 15.75C16.85 15.75 15.75 16.85 15.75 18.2C15.75 19.55 16.85 20.65 18.2 20.65C19.55 20.65 20.65 19.55 20.65 18.2C20.65 16.85 19.55 15.75 18.2 15.75Z",
    fill: "#5D9FE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsSearch);
export default __webpack_public_path__ + "static/media/SMS_Search.cb0f373dca0264b4678539645bd07007.svg";
export { ForwardRef as ReactComponent };